import axios from 'axios'

export const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 10000
})

export const apiHttpClient = axios.create({
  baseURL: process.env.VUE_APP_API_HOST + '/v1',
  timeout: 10000
})

export const odbHttpClientV3 = axios.create({
  baseURL: process.env.VUE_APP_ODB_API_BASE_URL + '/v3',
  timeout: 10000
})
